import Vue from "vue";
import { Hooper, Slide, Pagination } from "hooper";
import "hooper/dist/hooper.css";

Vue.component("hooper-container", Hooper);
Vue.component("hooper-slide", Slide);
Vue.component("hooper-pagination", Pagination);
